import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiShare2, FiHeart, FiUsers } = FiIcons;

const ShareAppButton = ({ variant = 'primary', className = '' }) => {
  const handleShareApp = async () => {
    const shareData = {
      title: 'Sulit PH: Senior & PWD Calculator',
      text: 'Hi! I use this helpful app for calculating Senior Citizen and PWD discounts. It works even without internet! Download it here:',
      url: window.location.origin
    };

    if (navigator.share) {
      try {
        await navigator.share(shareData);
        if (window.gtag) {
          window.gtag('event', 'share_app_clicked', { 'event_category': 'engagement' });
        }
      } catch (err) {
        console.log('Share cancelled or failed');
      }
    } else {
      // Fallback: Copy to clipboard
      try {
        await navigator.clipboard.writeText(`${shareData.text} ${shareData.url}`);
        alert('App link copied to clipboard! You can now paste and send it to your friends.');
      } catch (err) {
        alert('Could not share. Please copy the website URL manually.');
      }
    }
  };

  if (variant === 'icon') {
    return (
      <motion.button
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        onClick={handleShareApp}
        className={`w-10 h-10 rounded-full bg-pink-50 flex items-center justify-center text-pink-600 hover:bg-pink-100 transition-colors ${className}`}
        title="Share App with Friends"
      >
        <SafeIcon icon={FiHeart} className="text-xl" />
      </motion.button>
    );
  }

  return (
    <motion.button
      whileHover={{ scale: 1.02 }}
      whileTap={{ scale: 0.98 }}
      onClick={handleShareApp}
      className={`w-full bg-white border-2 border-pink-200 text-pink-600 py-4 rounded-2xl font-black text-lg flex items-center justify-center gap-3 hover:bg-pink-50 transition-all ${className}`}
    >
      <SafeIcon icon={FiUsers} className="text-xl" />
      SEND TO A FRIEND
    </motion.button>
  );
};

export default ShareAppButton;